import { render, staticRenderFns } from "./ParcelMenuItem.vue?vue&type=template&id=1c33eaff&scoped=true"
import script from "./ParcelMenuItem.vue?vue&type=script&lang=ts"
export * from "./ParcelMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33eaff",
  null
  
)

export default component.exports